import type { OfferPreset } from "../../types"

import hero from "@/features/offers/assets/astrology/hero.webp"
import feature1 from "@/features/offers/assets/astrology/feature-1.svg"
import feature2 from "@/features/offers/assets/astrology/feature-2.svg"
import feature3 from "@/features/offers/assets/astrology/feature-3.svg"
import gift from "@/features/offers/assets/astrology/gift.webp"
import card1 from "@/features/offers/assets/astrology/card-1.webp"
import card2 from "@/features/offers/assets/astrology/card-2.webp"
import card3 from "@/features/offers/assets/astrology/card-3.webp"
import chipSun from "@/features/offers/assets/astrology/chip-sun.svg"
import chipMoon from "@/features/offers/assets/astrology/chip-moon.svg"
import chipCareer from "@/features/offers/assets/astrology/chip-career.svg"
import chipWork from "@/features/offers/assets/astrology/chip-work.svg"
import chipGrowth from "@/features/offers/assets/astrology/chip-growth.svg"
import chipPhysical from "@/features/offers/assets/astrology/chip-physical.svg"
import chipEmotional from "@/features/offers/assets/astrology/chip-emotional.svg"
import chipIntellectual from "@/features/offers/assets/astrology/chip-intellectual.svg"
import reviewer1 from "@/features/offers/assets/reviews/reviewer-1.webp"
import reviewer2 from "@/features/offers/assets/reviews/reviewer-2.webp"
import reviewer3 from "@/features/offers/assets/reviews/reviewer-3.webp"

export const astrologyPreset: OfferPreset = {
  key: "astrology",
  stepLabel: "Stars",
  unlockedLabel: "Exclusive Astrology Report unlocked",
  hero: {
    title: "Unlock Your Astrology Report",
    subtitle:
      "Go deeper than your first reading and discover what your stars reveal about your personality, timing, relationships, and future path.",
    bg: hero,
  },
  benefits: [
    {
      icon: feature1,
      title: "Understand yourself deeper",
      subtitle: "Reveal how your stars reflect your strengths, emotions, and decisions",
    },
    {
      icon: feature2,
      title: "Find relationship harmony",
      subtitle: "See how astrology explains compatibility, attraction, and connection",
    },
    {
      icon: feature3,
      title: "Reveal your future direction",
      subtitle: "Explore what your stars suggest about relationships and opportunities",
    },
  ],
  gift: {
    title: "Natal Chart Snapshot",
    subtitle: "Preview your Sun, Moon, and Ascendant signs before opening the full report",
    image: gift,
    strikePrice: "$19.99",
  },
  price: {
    heading: "Your Complete Star Reading Starts Here",
    reportLabel: "Astrology Report",
    giftLabel: "Natal Chart Snapshot",
  },
  ctaLabel: "Unlock Astrology Report",
  featureCards: {
    heading: "Discover What Your Stars Reveal About Your Life",
    cards: [
      {
        image: card1,
        title: "Personal Overview",
        subtitle:
          "Explore how your Sun, Moon, and Ascendant shape your personality, emotions, and self-image.",
        chips: [
          { icon: chipSun, label: "Sun Energy" },
          { icon: chipMoon, label: "Moon Energy" },
        ],
      },
      {
        image: card2,
        title: "Career & Vocation",
        subtitle:
          "Discover what your sign may reveal about work style, growth, and the environments where you thrive",
        chips: [
          { icon: chipCareer, label: "Career" },
          { icon: chipWork, label: "Work Energy" },
          { icon: chipGrowth, label: "Growth" },
        ],
      },
      {
        image: card3,
        title: "Life Path Insights",
        subtitle:
          "Understand when your energy may support action, reflection, or clearer decisions",
        chips: [
          { icon: chipPhysical, label: "Physical", tone: "purple" },
          { icon: chipEmotional, label: "Emotional", tone: "peach" },
          { icon: chipIntellectual, label: "Intellectual", tone: "cyan" },
        ],
      },
    ],
  },
  reviews: {
    heading: "What users say after unlocking their report",
    items: [
      {
        avatar: reviewer1,
        name: "Maya Collins",
        rating: "5",
        text: "I expected a simple horoscope, but the report felt much more personal. The Sun and Moon sections helped me understand why I react the way I do.",
      },
      {
        avatar: reviewer2,
        name: "Sophie Grant",
        rating: "4.9",
        text: "The financial and career parts were surprisingly useful. It gave me a new way to think about my habits, timing, and next steps.",
      },
      {
        avatar: reviewer3,
        name: "Daniel Brooks",
        rating: "5",
        text: "I liked that it wasn't just about my zodiac sign. The report connected personality, relationships, and life direction in a way that felt clear.",
      },
    ],
  },
}
